import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'react-bootstrap';
import { orderPatternOperations } from "./state";
import { EDIT_ORDERPATTERN, NEW_ORDERPATTERN } from "./routes";
import '../../../includes/custom/css/common.css';
import ModuleHeader from '../../components/ModuleHeader';
import TableTemplate from '../../components/TableTemplate';

class OrderPattern extends Component {

    componentDidMount() {
        this.props.fetchDefault();
    }

    addOrderPattern = () => {
        this.props.history.push(NEW_ORDERPATTERN);
    }

    editOrderPattern = (row) => {
        this.props.history.push(EDIT_ORDERPATTERN + "/" + row.controlPatternCode);
    }

    copyOrderPattern = (data) => {
        this.props.history.push({
            pathname: NEW_ORDERPATTERN,
            state: { copied: data }
        });
    }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"発注制御パターン一覧"} />

                    <TableTemplate
                        {...this.props}
                        rowButtons={[
                            {
                                onClick: this.editOrderPattern,
                                icon: ['far', "edit"],
                                bsStyle: "link"
                            },
                            {
                                onClick: this.copyOrderPattern,
                                icon: ['far', "copy"],
                                bsStyle: "link"
                            }
                        ]}
                    />

                    <center>
                        <Button
                            className="button-common"
                            onClick={() => this.addOrderPattern()}
                        >
                            新規登録
                        </Button>
                    </center>

                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tableHeader: state.orderPattern.tableHeader,
        tableColumns: state.orderPattern.tableColumns,
        tableList: state.orderPattern.list
    }
};

const mapDispatchToProps = {
    fetchDefault: orderPatternOperations.fetchDefault,
    viewOrderPattern: orderPatternOperations.viewOrderPattern
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderPattern)